
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/developer/api-reference",
      function () {
        return require("private-next-pages/developer/api-reference.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/developer/api-reference"])
      });
    }
  